import React from 'react';
import {Footer} from '../../_common/components/Footer/Footer';
import {useBankStatementsContext} from '../context/BankStatementsContext';

export const BankStatementsFooter = () => {
  const {tableRows} = useBankStatementsContext();

  return <Footer count={tableRows.length}/>;
};
